module.exports = __webpack_public_path__ + "img/bar.1cce94dc.svg";